(() => {
  const registryKey = '__menoplayPdpActivation';
  window[registryKey]?.destroy();

  const controllers = new Map();
  const lifecycleController = new AbortController();
  const destroy = (id) => {
    controllers.get(id)?.abort();
    controllers.delete(id);
  };

  const rootsIn = (scope) => {
    if (scope?.matches?.('[data-menoplay-pdp-module="activation"]')) return [scope];
    return [...(scope?.querySelectorAll?.('[data-menoplay-pdp-module="activation"]') || [])];
  };

  const init = (scope = document) => {
    rootsIn(scope).forEach((root) => {
      const id = root.dataset.sectionId || 'activation';
      destroy(id);

      const controller = new AbortController();
      controllers.set(id, controller);

      const section = root.querySelector('.menoplay-pdp-activation-section');
      const cards = [...root.querySelectorAll('.menoplay-pdp-activation-card')];
      if (!section || !cards.length) return;

      cards.forEach((card, index) => {
        card.style.setProperty('--menoplay-activation-reveal-delay', `${Math.min(index * 60, 180)}ms`);
      });

      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        section.classList.add('is-revealing');
        observer.disconnect();
      }, { rootMargin: '0px 0px -18% 0px', threshold: 0.18 });

      controller.signal.addEventListener('abort', () => observer.disconnect(), { once: true });
      observer.observe(section);
    });
  };

  document.addEventListener('shopify:section:load', (event) => init(event.target), { signal: lifecycleController.signal });
  document.addEventListener('shopify:section:unload', (event) => {
    rootsIn(event.target).forEach((root) => destroy(root.dataset.sectionId || 'activation'));
  }, { signal: lifecycleController.signal });

  init();
  window[registryKey] = {
    destroy: () => {
      lifecycleController.abort();
      controllers.forEach((controller) => controller.abort());
      controllers.clear();
    },
  };
})();
